"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noop = function () { return null; };
exports.identity = function (val) { return val; };
//# sourceMappingURL=utils.js.map